import { DistrictListOrdering, useDistrictListQuery } from '../queries';
import { DistrictListFilter } from './components/district-list-filter';
import { querySchema } from './components/district-list-filter.schema';
import { DistrictListTable } from './components/district-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Button } from '~/components/Button/Button';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);
  const { can } = useAuthentication();

  const { data, isLoading } = useDistrictListQuery({
    ordering: values.ordering as DistrictListOrdering,
    page_size: values.pageSize,
    page: values.pageIndex,
    search: values.search,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Distriktkatalog" />

        {can('create-district') && (
          <Link to="create">
            <Button type="button">Skapa ny</Button>
          </Link>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <DistrictListFilter />
        <DistrictListTable districts={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
